import { createNamespacedHelpers } from "vuex-composition-helpers"
import { AppleGiftCardState } from "../store/apple-gift-card/state"
import { AppleGiftCardGetters } from "../store/apple-gift-card/getters"
import { AppleGiftCardActions } from "../store/apple-gift-card/actions"
import { AppleGiftCardMutations } from "../store/apple-gift-card/mutations"
import { ref, watch } from "@vue/composition-api"
const { useState, useActions, useGetters } = createNamespacedHelpers<
  AppleGiftCardState,
  AppleGiftCardGetters,
  AppleGiftCardActions,
  AppleGiftCardMutations
>("appleGiftCard")

export default () => {
  const { isLoggedIn } = useState(["isLoggedIn"])
  const { fissionActivityValid } = useGetters(["fissionActivityValid"])
  const fissionId = ref("")
  const { getMyFission } = useActions(["getMyFission"])

  fissionActivityValid.value &&
    watch(
      isLoggedIn,
      async () => {
        if (isLoggedIn.value) {
          getMyFission().then(fission_id => {
            fissionId.value = fission_id
          })
        }
      },
      {
        immediate: true
      }
    )

  return {
    fissionId
  }
}
